import { DataFromUrl, TRANSLATION, Yup, JOB_STAGES} from '@/imports-files/pages/clients/jobs/new';

export function getInitalValues(interviewTypes, stageTypes, jobOwner, router, current_step){
  // const jobId = router.query.job_id
  // const jobId  = window.location.pathname.split('/').slice(-2)[0];
  const jobId     =   new DataFromUrl().getJobId();

  const intialValue = {
    job: {
      id: jobId,
      step: current_step,
      job_stages_attributes: [
        { 
          stage_id: stageTypes.filter((e) => { return e.name == JOB_STAGES.APPLIED })[0].id,
          interview_type_id: '',
          _destroy: false,
          member_emails: [],
          member_initials: [],
          editable_deletable: false
        },
        { 
          stage_id: stageTypes.filter((e) => { return e.name == JOB_STAGES.SCREENING })[0].id,
          interview_type_id: '',
          _destroy: false,
          stage_emails: '',
          job_stage_label_attributes: {
            label: ''
          },
          placeholder: 'Shortlist',
          member_emails: [],
          member_initials: [],
          editable_deletable: true,
          date_id: Date.now(),
          automation: false,
        },
        { 
          stage_id: stageTypes.filter((e) => { return e.name == JOB_STAGES.INTERVIEW })[0].id,
          interview_type_id: '',
          _destroy: false,
          stage_emails: '',
          job_stage_label_attributes: {
            label: ''
          },
          placeholder: 'Interview 1',
          member_emails: [],
          member_initials: [],
          editable_deletable: true,
          date_id: Date.now(),
          automation: false,
        },
        { 
          stage_id: stageTypes.filter((e) => { return e.name == JOB_STAGES.OFFERED })[0].id,
          interview_type_id: '',
          _destroy: false,
          member_emails: [],
          member_initials: [],
          editable_deletable: false
        },
        { 
          stage_id: stageTypes.filter((e) => { return e.name == JOB_STAGES.HIRED })[0].id,
          interview_type_id: '',
          _destroy: false,
          member_emails: [],
          member_initials: [],
          editable_deletable: false
        }
      ]
    }
  }

  return intialValue;
}

export function getEditInitalValues(job, current_step)
{
  const job_stages_attributes = job.job_stages_attributes.map((x) => {
    if([JOB_STAGES.SCREENING, JOB_STAGES.INTERVIEW].includes(x.stage)){
      var interview_stage =  {id: x.id, stage_id: x.stage_id, job_id: x.job_id, interview_type_id: x.interview_type_id, _destroy: false, member_emails: x.members.map((x) => x.email), member_initials: x.members.map((x) =>{ return {email: x.email, name_initials: x.name_initials, name: x.name,  photo_url: x.photo_url}}),job_stage_label_attributes: x.job_stage_label_attributes, editable_deletable: x.editable_deletable || false, automation: x.automation}
      if(!interview_stage.job_stage_label_attributes)
      {
        interview_stage.job_stage_label_attributes = { label: 'Interview' }
      }
      return interview_stage
    }
    else{
      return {id: x.id, stage_id: x.stage_id, job_id: x.job_id, interview_type_id: x.interview_type_id, _destroy: false, member_emails: x.members.map((x) => x.email), member_initials: x.members.map((x) =>{ return {email: x.email, name_initials: x.name_initials, name: x.name, photo_url: x.photo_url}}), editable_deletable: x.editable_deletable || false, automation: x.automation}
    }
  })
  return { job : {step: current_step, job_stages_attributes: job_stages_attributes} }
}



export function getValidationSchema(interviewTypes, stageTypes, submitState, job_status){
  let validationRequired = !(submitState == 'draft' || (submitState == 'preview' && job_status != 'active'))
  let screeningTypeId = stageTypes.filter((e) => { return e.name == JOB_STAGES.SCREENING })[0]?.id
  let interviewTypeId = stageTypes.filter((e) => { return e.name == JOB_STAGES.INTERVIEW })[0]?.id
  const validationSchema = Yup.object().shape({
    job: Yup.object().shape({
                                job_stages_attributes: Yup.array().of(
                                                                          Yup.object({
                                                                                        stage_id: Yup.string().required(TRANSLATION('common:errors:required')),
                                                                                        _destroy: Yup.boolean(),
                                                                                        placeholder: Yup.string(),
                                                                                        job_stage_label_attributes: Yup.object().when(["stage_id", "_destroy", "placeholder"],{
                                                                                          is: (stage_id, _destroy, placeholder) => {
                                                                                           return (!_destroy &&  validationRequired && [interviewTypeId?.toString(), screeningTypeId?.toString()].includes(stage_id) && !(placeholder?.length > 0))
                                                                                          },
                                                                                          then: Yup.object().shape({
                                                                                            label: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true)
                                                                                          })
                                                                                        })
                                                                                    })
                              )
  })
});
  return validationSchema;
}